const validate = values => {
    const errors = {};

    if (!values.region) {
        errors.region = "Requis.";
    }

    if (!values.department) {
        errors.department = "Requis.";
    }
    if (
        !values.natureTypes ||
        (values.natureTypes && values.natureTypes.length === 0)
    ) {
        errors.natureTypes = "Requis.";
    }

    if (!values.description) {
        errors.description = "Requis.";
    }

    if (values.description && values.description.length > 600) {
        errors.description = "600 caractères maximum.";
    }
    if (!values.publicAddress) {
        errors.publicAddress = "Requis.";
    }
    if (!values.publicPostalCode) {
        errors.publicPostalCode = "Requis.";
    }
    if (!values.publicCity) {
        errors.publicCity = "Requis.";
    }
    if (!values.dateEvent) {
        errors.publicCity = "Requis.";
    }
    if (!values.priceCheckbox) {
        errors.priceCheckbox = "Requis.";
    }
    if (!values.openHour) {
        errors.openHour = "Requis.";
    }

    if (!values.ownerPublicName) {
        errors.ownerPublicName = "Requis.";
    }
    if (!values.ownerPublicPhone) {
        errors.ownerPublicPhone = "Requis.";
    }

    if (!values.rgpd) {
        errors.rgpd =
            "Vous devez accepter la politique de protection des données personnelles.";
    }

    if (!values.structureName) {
        errors.structureName = "Requis.";
    }

    if (!values.ownerPrivateAddress) {
        errors.ownerPrivateAddress = "Requis.";
    }

    if (!values.ownerPrivatePostalCode) {
        errors.ownerPrivatePostalCode = "Requis.";
    }

    if (!values.ownerPrivateCity) {
        errors.ownerPrivateCity = "Requis.";
    }

    if (!values.ownerPrivatePhone) {
        errors.ownerPrivatePhone = "Requis.";
    }

    if (!values.ownerPrivateEmail) {
        errors.ownerPrivateEmail = "Requis.";
    }

    return errors;
};

export default validate;
